import FrameBuffer from "_src/engine/framebuffer";
import { pixelBufferType, RBIntFormat } from "_src/engine/constants";
import resourceManager from "_src/render_graph/resource_manager";

import Pass from "_src/render_graph/pass";

export default class ReadColorPass extends Pass {

  constructor(attachmentsStorage, camera) {

    super(attachmentsStorage);

    this.init(camera);

  }

  init(camera) {

    const scene = this._addScene(camera);
    scene.setClearColor(1.0, 1.0, 1.0, 0.0);

  }

  update() {

    const scene = this.getMainScene();
    const width = scene.camera.viewport[2];
    const height = scene.camera.viewport[3];

    const frameBuffer = this.initFramebuffer(width, height);

    scene.setFramebuffer(frameBuffer);

  }

  initFramebuffer(width, height) {

    const usedTexture = this.getColorAttachment(0);
    const colorBuffer = usedTexture ? usedTexture : resourceManager.initBuffer(pixelBufferType.T_RGBA,
        { width, height });

    const usedBuffer = this.getDepthAttachment();
    const format = RBIntFormat.DS;
    const depthBuffer = usedBuffer ? usedBuffer : resourceManager.initBuffer(pixelBufferType.RB_DEPTH,
        { width, height, format });

    return new FrameBuffer([colorBuffer], depthBuffer);

  }

}
